import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import Select from '../ui/Select';
import ApplicationContext from '../ApplicationContext';
import { EmailTemplate } from '../fms.core/EmailTemplate';

function EmailTemplateDropDown({
                            value,
                            onChange = () => {},
                            disabled,
                            name=undefined,
                            reportType,
                          }: {
  value:string|null|undefined,
  onChange?:(x:string|null,) => void,
  disabled?: boolean,
  name?:string|undefined,
  reportType: string,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<EmailTemplate>>([]);

  async function fetchData(api:any) {
    const data = await appContext.api.getEmailTemplateList(reportType);
    if (data && data.result.length > 0) {
      setData(data.result);
    }

    if(value === null || value === undefined){
      const defaultTemplate = data.result.find((x:any) => x.typeDefault);
      if(defaultTemplate) {
        onChange(defaultTemplate.name);
      } else {
        const defaultSignature = data.result.find((x: any) => x.name === 'Email Signature');
        if(defaultSignature) {
          onChange(defaultSignature.name);
        }
      }
    }
  }

  useEffect(() => {
      fetchData(appContext.api);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function handleChange(e:any) {
    onChange(e.target.value || null);
  }
  const displayData = [
    ...data.map(x => ({ value: x.name, label: x.name}))
  ];

  return (
    <Select
      name={name}
      value={(value === null || value === undefined) ? '' : value}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
    />
  );
}

EmailTemplateDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
};

EmailTemplateDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default React.memo(EmailTemplateDropDown);
